import { useWindowDimensions, View } from 'react-native'
import useRWD from '@ui/theme/useRWD'

import { ModalSetter } from '../types'
import PersonalDetails from './sections/PersonalDetails'
import ContactDetails from './sections/ContactDetails'
import AddressDetails from './sections/AddressDetails'
import InvoiceDetails from './sections/InvoiceDetails'
import { gap } from '@ui/theme/values'
import { PoliciesSection } from '@user/customer/policies'

interface Props {
  setModal: ModalSetter
}

export default function CustomerAccountDetails({ setModal }: Props) {
  const { width: screenCurr } = useWindowDimensions()
  const {
    screen: { width: screenMax },
  } = useRWD()
  const containerProps = {
    style: {
      width: (screenCurr - 3 * gap) / 2,
      maxWidth: (screenMax - 3 * gap) / 2,
    },
  }

  const openPersonalModal = () => setModal('personal')
  const openContactModal = () => setModal('contact')
  const openAddressModal = () => setModal('address')
  const openInvoiceModal = () => setModal('invoice')
  const openPoliciesModal = () => setModal('policies')

  return (
    <View className="flex flex-row gap-8 px-8">
      <View {...containerProps} className="flex flex-col gap-8">
        <PersonalDetails onPress={openPersonalModal} />
        <AddressDetails onPress={openAddressModal} />
        <PoliciesSection onPress={openPoliciesModal} />
      </View>
      <View {...containerProps} className="flex flex-col gap-8">
        <ContactDetails onPress={openContactModal} />
        <InvoiceDetails onPress={openInvoiceModal} />
      </View>
    </View>
  )
}
